import { useI18n } from 'vue-i18n'

/**
 * A notification in the reader's own language.
 *
 * `title`/`message` are the English original stored at write time — it is what
 * an email carries and it is the fallback here too. `titleKey`/`messageKey`
 * are resolved against the CURRENT locale instead, which is the whole point of
 * translating on read: a notification from Monday, opened today by someone who
 * switched language since, still comes out in the language they read it in now.
 *
 * `te()` guards the lookup on purpose. A category some module forgot to add to
 * one of the four languages must not surface as the raw key
 * ('incidents.notifications.reported.low') sitting in someone's feed — the
 * English original is a better failure than that.
 */
export function useLocalizedNotification() {
  const { t, te } = useI18n()

  const resolve = (key, fallback, params) => (key && te(key) ? t(key, params ?? {}) : fallback)

  return {
    title: (notification) => resolve(notification.titleKey, notification.title, notification.params),
    message: (notification) => resolve(notification.messageKey, notification.message, notification.params),
  }
}
